<template>
  <section class="contract-hero">
    <div class="contract-hero__main">
      <span class="contract-hero__eyebrow">SHIFT SCHEDULING</span>
      <h3>{{ contract.client_name || "Contract Schedule" }}</h3>
      <p>
        <i class="ti ti-location-pin"></i>
        {{ contract.office_address || "Alamat kontrak belum tersedia" }}
      </p>

      <div class="contract-summary">
        <div class="summary-item">
          <span class="summary-item__icon"><i class="ti ti-calendar"></i></span>
          <div>
            <small>Contract Period</small>
            <strong>{{ contract.start_date }} - {{ contract.end_date }}</strong>
          </div>
        </div>

        <div class="summary-item">
          <span class="summary-item__icon"><i class="ti ti-user"></i></span>
          <div>
            <small>Technician</small>
            <strong>{{ employeeTotal || employees.length }} Assigned</strong>
          </div>
        </div>

        <div class="summary-item">
          <span class="summary-item__icon"><i class="ti ti-time"></i></span>
          <div>
            <small>Current Period</small>
            <strong>{{ filterDate }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="contract-hero__meta">
      <span class="contract-status" :class="contract.status | contractStatus">
        {{ contract.status | cleanString }}
      </span>
      <small>Contract Number</small>
      <strong>{{ contract.contract_number || "-" }}</strong>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeaderContract",

  components: {
    // DatePicker,
  },

  props: {
    employees: {
      type: Array,

      default: () => [],
    },
    employeeTotal: {
      type: Number,
      default: 0,
    },
    contract: {
      type: Object,
      required: true,
    },

    filterDate: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      localFilterDate: this.filterDate,
    };
  },

  watch: {
    filterDate(val) {
      this.localFilterDate = val;
    },
  },

  methods: {
    changeMonth() {
      this.$emit("update:filterDate", this.localFilterDate);

      this.$emit("change-period");
    },
  },
};
</script>

<style scoped>
.contract-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(45, 111, 145, 0.16);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 178px;
  overflow: hidden;
  padding: 24px 28px;
  position: relative;
}

.contract-hero::after {
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
  content: "";
  height: 250px;
  position: absolute;
  right: -65px;
  top: -120px;
  width: 250px;
}

.contract-hero__main,
.contract-hero__meta {
  position: relative;
  z-index: 1;
}

.contract-hero__main {
  max-width: 75%;
}

.contract-hero__eyebrow {
  color: #c7f4eb;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1.2px;
}

.contract-hero h3 {
  color: #fff;
  font-size: 23px;
  font-weight: 700;
  margin: 5px 0;
}

.contract-hero p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11px;
  margin: 0 0 17px;
}

.contract-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.summary-item {
  align-items: center;
  background: rgba(255, 255, 255, 0.11);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 9px;
  display: flex;
  min-width: 175px;
  padding: 8px 11px;
}

.summary-item__icon {
  align-items: center;
  background: rgba(255, 255, 255, 0.14);
  border-radius: 7px;
  display: flex;
  flex: 0 0 auto;
  height: 29px;
  justify-content: center;
  margin-right: 9px;
  width: 29px;
}

.summary-item small {
  display: block;
  color: rgba(255, 255, 255, 0.68);
  font-size: 9px;
}

.summary-item strong {
  color: #fff;
  display: block;
  font-size: 11px;
  margin-top: 1px;
}

.contract-hero__meta {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  min-width: 220px;
  text-align: right;
}

.contract-status {
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 13px;
  font-size: 9px;
  font-weight: 700;
  margin-bottom: 14px;
  padding: 4px 9px;
  text-transform: uppercase;
}

.contract-hero__meta small {
  color: rgba(255, 255, 255, 0.68);
  font-size: 9px;
}

.contract-hero__meta strong {
  color: #fff;
  font-size: 13px;
  margin-top: 3px;
}

@media (max-width: 767px) {
  .contract-hero {
    align-items: stretch;
    flex-direction: column;
    padding: 22px 20px;
  }

  .contract-hero__main {
    max-width: none;
  }

  .summary-item {
    min-width: 100%;
  }

  .contract-hero__meta {
    align-items: flex-start;
    border-top: 1px solid rgba(255, 255, 255, 0.18);
    margin: 17px 0 0;
    min-width: 0;
    padding-top: 15px;
    text-align: left;
  }
}
</style>
